export const FORM_FIELD_NAMES = {
    DOMAIN: "domain"
}